export default (amount, currency) =>
  Number(amount).toLocaleString('hu-HU', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })
